import { render, staticRenderFns } from "./ServiceDynamic.vue?vue&type=template&id=1ec94b3c&scoped=true&"
import script from "./ServiceDynamic.vue?vue&type=script&lang=js&"
export * from "./ServiceDynamic.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDynamic.vue?vue&type=style&index=0&id=1ec94b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec94b3c",
  null
  
)

export default component.exports